// extracted by mini-css-extract-plugin
export default {"settings":"settings-settings-b0ScSa","nav":"settings-nav-OHZkrr","menu":"settings-menu-G6pVKu","link":"settings-link-W9kucS","activeLink":"settings-activeLink-D8i1i5"};